import { fromJS, Map } from 'immutable';

import { setStaticPage } from './actions';

export const defaultState = Map({
  isStaticPage: false,
  page: ''
});

export default function staticPage(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case setStaticPage.type:
      return newState.withMutations(state => {
        state.set('isStaticPage', true).set('page', action.payload);
      });

    default:
      return newState;
  }
}

export const isStaticPage = state => state.staticPage.get('isStaticPage');
